module.exports = __webpack_public_path__ + "static/media/subscribe_img.a90186ec.png";